import {
  fetchSubscriptionState,
  SOFTWARE_SUBSCRIPTION_STATES,
} from 'utilities/software';

/**
 * this is a list of preselcted add ons for products
 * format is as follows:
 * {
 *  [product_key]: [addOnCategory1, addOnCategory2, ...]
 * }
 */
const PRE_SELECTED_ADD_ONS = {
  's3b-kiosk': ['software_kiosk', 'bosstab_stand'],
  's3-mount': ['software_kiosk', 'bosstab_stand'],
};

/**
 *
 * @param {*} product
 * @returns addOns sorted into hardware or software
 */
const sortProductAddOnSections = (product) => {
  const addOns = product.add_ons;
  if (!addOns) {
    return [];
  }

  // since addOns are sorted by metadata category and not by taxon category
  // we need to check if the category is a software related one as they will be prefixed with 'software_'
  const softwareAddOnSections = [];
  const hardwareAddOnSections = [];

  Object.entries(addOns).forEach(([category, addOns]) => {
    if (category.startsWith('software_')) {
      softwareAddOnSections.push({ category, addOns });
    } else {
      hardwareAddOnSections.push({ category, addOns });
    }
  });

  return { softwareAddOnSections, hardwareAddOnSections };
};

/**
 * check if the product has any software add ons
 * @param {*} product
 * @returns boolean
 */
const checkAddOnsForSoftware = (product) => {
  const softwareAddOns =
    sortProductAddOnSections(product).softwareAddOnSections;
  return softwareAddOns.length > 0;
};

/**
 * extract software add ons from product
 * @param {*} currentProduct
 * @returns addOns
 */
const extractSoftwareAddOns = (product) => {
  const { softwareAddOnSections } = sortProductAddOnSections(product);
  return softwareAddOnSections.reduce((acc, section) => {
    return [...acc, ...section.addOns];
  }, []);
};

/**
 *
 * @param {*} addOns - list of addOns from an addOn category
 * @returns {boolean} true if any of the addOns have an active subscription
 */
const checkAddOnsForActiveSubscription = (addOns) => {
  return addOns.some((addOn) => {
    const subscriptionState = fetchSubscriptionState(addOn);

    return (
      subscriptionState === SOFTWARE_SUBSCRIPTION_STATES.ACTIVE_SUBSCRIPTION ||
      subscriptionState ===
        SOFTWARE_SUBSCRIPTION_STATES.SUBSCRIPTION_WITH_ACTIVE_SUPERSET
    );
  });
};

export {
  checkAddOnsForActiveSubscription,
  checkAddOnsForSoftware,
  extractSoftwareAddOns,
  sortProductAddOnSections,
  PRE_SELECTED_ADD_ONS,
};
